module.exports = __webpack_public_path__ + "body2-bg.png?c3f29526d1d5f6898ebdb079a234d29f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/body2-bg.png
// module id = 164
// module chunks = 0